interface Window {
    RDG: any;
    $: JQueryStatic;
}

(function ($) {

    //Declare in Global Namespace	
    (<any>window).RDG = (<any>window).RDG || {};
    (<any>window).RDG.Modal = {};

    // set default configurations
    var configurations = {
        name: "Modal",
        version: 1.1,
        delay: 10,
        openModalDelay: 500,
        resizeIframeHeightBuffer: 5
    };

    function setOverlayTrigger() {
        const triggers = document.getElementsByClassName('rdg-modal');
        if (triggers) {
            for (var i = 0; i < triggers.length; i++) {
                let trigger:any = triggers[i];
                const modalId = trigger.dataset.modalId;
                const modalTitle = trigger.dataset.modalTitle;
                const modalURL = trigger.href;
                const modalSize = trigger.dataset.modalSize;
                trigger.addEventListener('click', function(e){
                    e.preventDefault();
                    window.RDG.Modal.create(modalId, modalTitle, modalURL, modalSize);
                });
            }
        }

        const menuModalTriggers = document.getElementsByClassName('rdg-menu-modal');

        if (menuModalTriggers) {
            for (var i = 0; i < menuModalTriggers.length; i++) {
                let trigger:any = menuModalTriggers[i];
                const modalId = trigger.id;
                const link = trigger.querySelector('a');
                const modalTitle = link.getAttribute('title');
                const modalURL = link.href;
                const modalSm = 'menu-modal-sm';
                const modalMd = 'menu-modal-sm';
                const modalLg = 'menu-modal-lg';
                const modalXl = 'menu-modal-xl';
                let modalSize = '';
                if (trigger.classList.contains(modalSm)) modalSize = modalSm.replace("menu-","");
                if (trigger.classList.contains(modalMd)) modalSize = modalMd.replace("menu-","");
                if (trigger.classList.contains(modalLg)) modalSize = modalLg.replace("menu-","");
                if (trigger.classList.contains(modalXl)) modalSize = modalXl.replace("menu-","");

                link.addEventListener('click', function(e){
                    e.preventDefault();
                    window.RDG.Modal.create(modalId, modalTitle, modalURL, modalSize);
                });
            }
        }
        /* ######## Start Overlay ###ea####### */
        $(document).on("click", ".close-iframe-modal", function (e) {
            e.preventDefault();
            window.parent.$('.modal.show').modal('hide');
        });
        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            window.RDG.Modal.resizeParentIframe();
          });
    }

    function handleModaliFrameResize(iframe) {
        window.RDG.Modal.resizeIframe(iframe);
    }

    window.RDG.Modal = {
        config: configurations,
        init: function () {
            setOverlayTrigger();
        },
        create: function (modalId, modalTitle, contentSrc, size, isInline, backdrop, delay) {
            if (typeof modalId === "undefined") modalId = 'modal-overlay';
            if (typeof modalTitle === "undefined") modalTitle = null;
            if (typeof contentSrc === "undefined") contentSrc = null;
            if (typeof size === "undefined" || size === null) size = "";
            if (typeof backdrop === "undefined") backdrop = true;
            if (typeof delay === "undefined") delay = window.RDG.Modal.config.delay;

            if (modalId.includes('#')) modalId = modalId.substr(1);
            var hasInlineVideo;

            // Check for open modals and close if open
            var modalIsOpen = $('body').hasClass('modal-open') ? true : false;
            if (modalIsOpen) {
                window.RDG.Modal.close();
                delay = window.RDG.Modal.config.openModalDelay;
            }

            window.setTimeout(function () {
                // Modal Container
                var $modalContainer = $('<div/>', {
                    id: modalId,
                    'class': 'modal fade dynamic',
                    'role': 'dialog',
                    'arial-hidden': true
                });

                // Modal Dialog
                var $modalDialog = $('<div/>', {
                    'class': 'modal-dialog modal-dialog-centered ' + size,
                    'role': 'document'
                });

                $modalContainer.append($modalDialog);

                // Modal Content
                var $modalContent = $('<div/>', {
                    'class': 'modal-content'
                });

                $modalDialog.append($modalContent);

                // Modal Header
                var $modalHeader = $('<div/>', {
                    'class': 'modal-header'
                });

                $modalContent.append($modalHeader);

                if (modalTitle) {
                    // Modal Header Title
                    var $modalTitle = $('<h5/>', {
                        'class': 'modal-title',
                        id: modalId + '_title'
                    }).html(modalTitle);
                    $modalHeader.append($modalTitle);
                }

                // Modal Close Button
                var $closeButton = $('<button/>', {
                    'class': 'close',
                    'data-dismiss': 'modal',
                    'arial-label': 'Close'
                });

                $modalHeader.append($closeButton);

                // Modal Close Icon
                var $closeIcon = $('<span />', {
                    'aria-hidden': true
                }).html('&times');

                $closeButton.append($closeIcon);

                // Modal Content Body

                var $modalBody = $('<div/>', {
                    id: modalId + '-body',
                    'class': 'modal-body'
                });

                $modalContent.append($modalBody);

                if (isInline) {
                    $modalBody.addClass('inline-content');
                    var $contentSrc = $(contentSrc);
                    var $content = $(contentSrc).clone(true);
                    hasInlineVideo = $content.find('.video-player').length > 0 ? true : false;
                    // Disable/enable form inputs to prevent duplicate input issues
                    $contentSrc.find('input').prop("disabled", true);
                    $content.find('input').prop("disabled", false);
                    $content.removeClass('hidden');

                    var $popContainer = $('<div/>', {
                        'class': 'popup-container'
                    });

                    var $innerContent = $('<div/>', {
                        'class': 'inner-content'
                    });

                    $popContainer.appendTo($modalBody);
                    $innerContent.appendTo($popContainer);
                    $content.appendTo($innerContent);
                } else {
                    $modalBody.addClass('iframe-content');

                    var $iFrameWrapper = $('<div/>', {
                        'class': 'iframe-wrapper'
                    });

                    // Modal iFrame Content
                    var modaliFrame = document.createElement("iframe");
                    modaliFrame.id = "iframe-" + modalId;
                    modaliFrame.src = contentSrc;
                    modaliFrame.frameBorder = '0';
                    modaliFrame.width = '100%';
                    modaliFrame.setAttribute('allowFullScreen', 'true');
                    modaliFrame.setAttribute('webkitallowfullscreen', 'true');
                    modaliFrame.setAttribute('mozallowfullscreen', 'true');
                    modaliFrame.setAttribute('allowtransparency', 'true');


                    modaliFrame.onload = function () {
                        window.RDG.Modal.resizeIframe(this);
                        // @ts-ignore
                        window.addEventListener('resize', handleModaliFrameResize(this));
                    };
                    
                    $iFrameWrapper.append($(modaliFrame));

                    $modalBody.append($iFrameWrapper);
                }

                // Attach everything together and to the DOM
                $('body').prepend($modalContainer);

                // Open new modal
                var jQueryTargetRef = "#" + modalId;

                
                $(jQueryTargetRef).modal({
                    backdrop: backdrop,
                    keyboard: false
                });

                // Remove this Modal should it ever be closed
                $(jQueryTargetRef).on('hidden.bs.modal', function (e) {
                    // @ts-ignore
                    window.removeEventListener('resize', handleModaliFrameResize(modaliFrame));
                    $(jQueryTargetRef).remove();
                });

                // Close the drop down if it's open
                $('.user-menu').removeClass('show-menu');
            
            }, delay);

        },
        resizeModal: function () {
            $('.modal').modal('handleUpdate');
        },
        resizeIframe: function (iframe) {
            try {
                iframe.height = (iframe.contentWindow.document.body.scrollHeight + window.RDG.Modal.config.resizeIframeHeightBuffer) + "px";
            } catch (e) {
                console.log(e);
            }
        },
        resizeParentIframe: function () {
            try {
                var iframe = parent.document.getElementById(window.frameElement.id);
                parent.RDG.Modal.resizeIframe(iframe);
            } catch (e) {
                console.log(e);
            }
        },
        close: function () {
            $('.modal').modal('hide');
        }
    };
})(jQuery);

(function($) {
    window.RDG.Modal.init();
}(jQuery));
